import React, { Component } from 'react';
import PropsType from 'prop-types';

import '../../assets/scss/Protocol/protocol.scss';

class PartnerApply extends Component {
  render () {
    return (
      <div className='protocol-wrap'>
        <div className='protocol'>
          <div className='title' style={{ lineHeight: '0.34rem' }}>“挣推”平台<br />业务推广员注册协议</div>
          <div className='content'>
            <div className='item'>
              <p><strong>【审慎阅读】</strong></p>
              <p>尊敬的客户，欢迎您光临富士康科技集团旗下业务推广合作平台——“挣推”。为了您能便利、快捷的尊享我们提供的产品与服务，您需与我们签署本协议。<strong>您在点击同意注册之前，请务必审慎阅读、充分理解本协议中相关条款内容，其中包括：您的授权条款、与您约定免除或限制责任的条款、与您个人信息相关（包括定义、收集、存储、加工、披露等）的条款、与您约定法律适用和管辖的条款、其他以粗体下划线标识的重要条款。</strong></p>
            </div>
            <div className='item'>
              <p><strong>【特别提示】</strong></p>
              <p><strong className='line'>当您按照注册页面提示填写个人信息、查看本协议内容后，您在点击“同意”或“注册”或显示类似字眼的页面时，即表示您已充分阅读、理解并接受本协议的全部内容；若您注册成为我们的用户，则表示您对本协议的全部内容已充分阅读并认可和同意遵守，本协议即生效。</strong></p>
              <p>您须遵守中国法律、法规、规章及其他政府规范性文件规定，如有违反而造成任何法律后果，您将独立承担所有相应的法律责任；同时，我们有权立即中止或终止为您服务。</p>
              <p><strong className='line'>阅读本协议的过程中，如果您不同意本协议中任何条款约定，您应立即停止注册程序。</strong>如您对协议内容有疑问，您可于工作时间致电客服热线4009-303-606咨询。</p>
            </div>
            <div className='item'>
              <p>深圳市富龙小额贷款有限公司（本协议中简称“本公司”或“我们”)及运营的“挣推”平台（本协议中简称“挣推”）依据本协议的约定为挣推用户(本协议中简称“用户”或“您”)提供服务。<strong>本协议在用户和本公司之间具有合同上的法律效力，适用于用户在挣推的全部活动。本协议内容包括本协议全部条款及挣推已经发布的或将来可能发布的各类规则、通告。所有规则、通告为本协议不可分割的一部分,与本协议具有同等法律效力。<strong className='line'>我们有权根据运营需要不定时地制定、修改本协议或各类规则，挣推将随时刊载并公告本协议及规则变更情况。经修订的协议、规则一经公布，立即自动生效。</strong>对于协议、规则生效之前注册的用户，若用户在新规则生效后继续使用挣推提供的各项服务，则表明用户已充分阅读并认可和同意遵守新的协议或规则。若用户拒绝接受新的协议和规则，用户应立即放弃或终止继续使用挣推提供的各项服务，但该用户应承担在挣推已经进行的交易下所应承担的任何法律责任，且应遵循该用户发生交易时有效的协议或规则内容。</strong></p>
            </div>
            <div className='item'>
              <p><strong>一.  用户</strong></p>
              <p>1. <strong>您需保证：您必须为中华人民共和国法律规定的年满18周岁以上的，或法律规定满足其他条件的，具有完全民事权利和民事行为能力且能够独立承担民事责任的自然人，您具有从事本协议项下业务所需的资质。如您不符合此条件的，请勿注册。</strong>若您违反本条约定注册、使用挣推服务的，我们有权中止或终止您的资格、追究您相关法律责任，且由此而引发的损失和后果应由您自行承担。</p>
              <p><strong>2. 在注册成为挣推用户后，您应按照注册提示的内容完善身份信息，如真实姓名、职业、手机号码等。挣推部分服务需要用户实名认证的（如提取推广佣金、推广奖励等），用户应按照提示的内容完善身份证号、银行卡号等信息，以便我们向合作的实名认证方对您的身份信息、收款银行卡信息进行实名核验及活体检测（如需要），否则此部分功能会无法使用。</strong></p>
            </div>
            <div className='item'>
              <p><strong>二.  合作内容</strong></p>
              <p>1. <strong>您成为挣推用户后，您可获得我们为您生成的指定产品专属邀请链接或二维码；您可将邀请链接或二维码发送至目标客群用户，他们可通过您分享的链接或二维码注册成为我们指定产品用户并进行后续操作。</strong></p>
              <p>2. <strong>如您邀请的目标客群用户使用我们指定的产品后，您可获得一定的推广佣金；如您邀请的目标客群用户使用我们指定的产品达到一定金额，您可获得一定的推广奖金。</strong></p>
              <p>3. <strong>如您邀请的目标客群用户使用我们指定的产品，且您邀请的目标客群用户达到一定数量时，或您邀请的目标客群用户有一定数量转化为挣推推广员的，您有机会从推广员晋级团队管理员，并有机会分享您所管理团队的佣金。</strong></p>
              <p>4. <strong>因业务存在发展及变化，我们的推广佣金、推广奖金、团队佣金亦会根据业务发展情况及变化进行修改，您知悉并同意：推广佣金、推广奖金、团队佣金（包括以后可能新增的其它奖励费用）的计算规则、发放规则，以挣推平台不时发出的公告为准。</strong></p>
              <p>5. <strong>您知悉并同意：纳税是每个中国公民应尽的义务，您同意我们在向您发放推广佣金、推广奖金、团队佣金前，对您依法应纳的个人所得税进行代扣代缴。</strong></p>
              <p>6. <strong>费用结算以我们提供的数据为准。若您对我们提供的结算数据存在异议，您有权要求复核。若您核查数据与我们提供的结算数据出现差异，双方可协商解决。如您无直接且有效的证据证明我们数据有误，则最终仍以我们数据作为结算依据。</strong></p>
              <p>7. <strong>您知悉并确认，我们授予您的是非独家地宣传、推广我们授权您宣传、推广的产品的权利，您不可再转授权他人，且我们有权随时无条件撤回授权。</strong></p>
              <p>8. 如我们有新的产品提供，将会在挣推中公布详细的产品内容及费用情况，请您密切关注，一旦您选择该产品，将视同您完全接受该产品内容及收费标准。</p>
            </div>
            <div className='item'>
              <p><strong>三.  用户的权利和义务</strong></p>
              <p>1. <strong>您在注册使用挣推服务时应按要求提供真实、最新、有效及完整的资料，并且授予我们基于提供产品及服务的目的，对您提供的资料及数据信息拥有无偿的使用权利。同时，您有义务维持并更新注册的资料，确保其为真实、最新、有效及完整的资料。如因您未及时更新资料，导致我们的服务无法提供或提供时发生任何错误，我们对此不承担任何责任。</strong></p>
              <p>2. <strong>若您提供任何错误、不实或不完整的资料，或我们有理由怀疑资料为错误、不实或不完整及违反本协议的，或您的资料、言行等有悖于挣推平台运营综旨的，我们有权中止或终止您使用帐号，中止或终止提供全部或部分服务。</strong></p>
              <p>3. <strong>您成功注册成为挣推用户后，您应当妥善保管自己的用户名、密码、手势等信息，并不得将用户名转让、赠与或授权给第三方使用。您在此同意并确认，使用该用户名、密码、手势登录挣推及在挣推账户下发出的一切指令均视为您本人的行为和意思表示，该等指令一经做出即不可逆转，由此而产生的一切损失和后果（包括推广佣金、推广奖金、团队佣金被盗待等）均应由您本人自行承担。如您发现第三人冒用或盗用您账户及密码，应立即以有效方式通知我们并要求暂停相关服务，否则由此产生的一切责任由您本人承担。</strong>同时，您理解我们对您的请求采取行动需要合理期限，在此之前，我们对第三人使用您账户所导致的损失不承担任何责任。</p>
              <p>4. 您决定不再使用挣推账户时，应先与我们结清费用，并向我们申请关闭该账户，经我们审核同意后可正式关闭账户。<strong>您知悉：一旦申请关闭账户后将会导致用户数据删除，关闭账户后，我们将无法再为您提供数据查询服务，未结费用亦无数据支持再进行结算。</strong></p>
              <p>5. <strong className='line'>您清楚知悉，您与我们不存在劳动关系或劳务关系，您与我们之间是平等主体之间的业务合作关系，您在推广我们产品过程中所遭受的人身、财产损失由您自行承担，我们将会按推广规则向您发放佣金或奖金。</strong></p>
              <p>6. <strong>您应自费处理因您原因导致目标客户用户针对您的推广行为提出的投诉、举报、诉讼、仲裁、及任何其它程序，本公司不承担任何责任。</strong></p>
              <p>7. <strong>对于您自行制作的投放物料或宣传文案，在投放前必须经我们审核，且上线截图须向我们报备，否则，我们有权不与您结算有关费用。因未经我们审核的宣传文案或物料对我们造成的经济损失由您来承担。</strong></p>
              <p>8. 您不得以非法的方式使用挣推及/或我们的产品，且当发现挣推及/或我们的产品被任何第三方侵害，或您怀疑将要发生被侵害、模仿、非法使用或不正当使用时，应及时通知我们知晓。</p>
              <p>9. 您应保守在履行本协议期间所知悉的我们的商业密秘，未经我们许可，不可向任何第三方透露。</p>
              <p>10. 您同意我们通过拨打电话、发送短信、发送电子邮件、站内信等方式向您发布、推送、提供的各类通知信息，以及邀请您参与版本测试、用户体验反馈、回访等活动。</p>
              <p>11. 您有权向我们查询您自身信息的权利，有权要求我们更正、补充信息的权利，您也有权要求注销挣推账户的权利，账户注销后，我们会根据法律规定对您的信息做删除或匿名化处理。</p>
              <p>12. 用户死亡或被宣告死亡的，其在本协议项下的各项权利义务由其继承人承担。若用户丧失全部或部分民事权利能力或民事行为能力，其在本协议项下的各项权利义务由其监护人代为行使。</p>
              <strong>
                <p>13. 您不得有如下行为：</p>
                <div className='sub-content'>
                  <p>13.1 您不得对我们授权推广的产品向任何第三方做夸大、虚假陈述。未经我们授权，您不得向任何第三方做出与我们有关的承诺的。</p>
                  <p>13.2 您不得发布、传播侵犯我们或任何第三方的肖像权、名誉权、隐私权、专权、商标权、著作权、商业秘密的信息或言论。</p>
                  <p>13.3 您在推广我们的产品过程中，您不得擅自修改我们产品LOGO、产品包签名、产品名称、产品介绍、推广语、产品截图等信息，不得误导用户下载我们的产品，不得在色情、赌博等非法网站、频道或移动终端上推广我们的产品。</p>
                  <p>13.4 您在推广我们的产品过程中，您不得以任何名义、任何方式向使用我们产品的客户收取任何性质的费用（包括但不限于咨询费、服务费、审批费等）。</p>
                  <p>13.5 您推广我们的产品过程中，您不得以任何方式协助任何人通过虚构信息、资料包装等手段以协助其使用我们的产品。如我们发现您存有任何违法违规行为，我们有权采取扣发相关佣金或奖金、冻结您的合作资格、取消您的合作资格等措施。如涉及刑律，我们将依法报警方处理，追究法律责任。</p>
                  <p>13.6 您不得以任何方式干扰或企图干扰挣推的任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法。</p>
                  <p>13.7 您应按照挣推的流程、规则进行注册、认证或使用服务，不得违反挣推的功能限制或运营策略，或采取任何措施规避前述流程、规则、限制或策略。</p>
                  <p>13.8 您不得利用挣推从事包括但不限于欺诈、传销、刷流量、好评、违法物品营销等任何违法兼职或犯罪活动。</p>
                  <p>13.9 您不得为任何第三方提供代办或协助他人代办身份认证服务的或代售身份认证所需的相关材料或凭据。</p>
                  <p>13.10 其他任何导致或可能导致我们与第三方产生纠纷、争议或诉讼的行为。</p>
                </div>
                <p>14. 您承诺不在挣推上从事任何可能违反中国现行的法律、法规、规章和规范性文件的行为以及本协议约定的违约行为，禁止从事下列制作、复制、发布、传播违反国家相关法律法规及七条底线、九不准管理规定的违法和不良信息的行为。您如有违反而导致任何法律后果的发生，您自己将独立承担所有相应的法律责任。同时，我们有权按照本协议约定追究您违约责任。</p>
                <div className='sub-content'>
                  <p>14.1 反对宪法所确定的基本原则的；</p>
                  <p>14.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                  <p>14.3 损害国家荣誉和利益，煽动民族仇恨、民族歧视、破坏民族团结的；</p>
                  <p>14.4 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                  <p>14.5 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                  <p>14.6 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                  <p>14.7 侮辱或者诽谤他人，侵害他人合法权利的；</p>
                  <p>14.8 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或有悖道德、令人反感的内容的；</p>
                  <p>14.9 含有中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的其它内容的。</p>
                </div>
              </strong>
            </div>
            <div className='item'>
              <p><strong>四.  我们的权利和义务</strong></p>
              <p>1. 我们负责挣推的开发、维护，以市面上通行技术保障挣推在移动终端的有效运行和不断优化。</p>
              <p>2. <strong>我们有权向您了解您的推广计划，有权对您的推广进行监督，有权要求您提供推广我们授权产品的渠道、内容，对我们存疑之处，您应给予说明，如我们认为您的推广行为存在违法违规之处的，我们有权要求您整改、中止推广。情况严重的，我们有权要求您终止推广，甚至有权冻结您挣推的账号以禁止您使用挣推。</strong></p>
              <p>3. <strong>我们有权根据业务的发展情况，制定或修改本协议内容，</strong>请注意关注挣推平台不时发出的公告。</p>
              <p>4. <strong>我们有权根据自身业务发展需要对我们的产品作出调整，包括但不限于变更结算方式、变更合作模式、变更我们产品名称、新增或减少我们产品的功能或内容等。</strong></p>
              <p>5. 我们保证对我们产品拥有合法的运营权利，享有合法的知识产权。</p>
              <p>6. 我们对您的信息予以严格保密，严格依据相关法律法规及政策之规定收集、保存、使用、共享、转让、披露及保护您的信息。</p>
            </div>
            <div className='item'>
              <p><strong>五.  涉及第三方网站或客户端</strong></p>
              <p>1. 挣推的部分内容可能涉及由第三方所有、控制或运营的其它网站或客户端，含有访问第三方网站或客户端的链接，我们会尽力要求第三方所提供的服务合法合规，给用户提供多样化且优惠的服务，<strong>但本公司无法保证第三方网站或客户端上信息的真实性和有效性。如用户使用第三方服务的，视同用户授权我们向第三方披露用户的部分信息，具体信息以用户使用第三方服务时的告知为准。</strong></p>
              <p>2. <strong>我们对所有第三方网站或客户端的隐私保护措施不承担任何责任。</strong></p>
              <p>3. 用户在使用第三方网站或客户端时，应遵守第三方网站或客户端的相关协议及使用规则。用户根据自身情况选择使用第三方服务，如有疑问或纠纷，须与第三方进行沟通解决，本公司不承担任何责任。</p>
              <p>4. <strong>用户通过第三方网站或客户端时（下称“第三方平台”）注册、登陆、使用我们服务的，将被视为用户完全了解、同意第三方平台将用户在第三方平台上填写、登记、公布、记录的全部信息（下称“第三方平台记录信息”）授权我们使用（使用方式包括但不限于收集、统计、分析等）。</strong></p>
            </div>
            <div className='item'>
              <p><strong>六.  知识产权</strong></p>
              <p>1. 我们对挣推及我们授权您推广的产品拥有完整、自主的知识产权，或已获得权利人充分的授权，您不得修改、删除我们产品的知识产权标识。</p>
              <p>2. 未经我们授权，您不得使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入挣推的服务和相关系统。</p>
              <p>3. 未经我们授权，您不得以任何目的自行或授权、允许、协助任何第三人采用任何技术手段【包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为】收集挣推的信息。</p>
              <p>4. 如您发现有任何第三方侵犯我们的知识产权或其他合法权益，应及时通知我们。我们有权自主决定是否采取行动，采取何种行动。</p>
            </div>
            <div className='item'>
              <p><strong>七.  违约责任</strong></p>
              <p>1. <strong>如您在推广我们授权产品时存在虚构信息、欺诈行为，或因您的推广而导致我们声誉受损、被行政处罚、被第三方索赔的，我们有权不予向您结算应结费用，同时我们所遭受的损失的，我们有权向您索赔。</strong></p>
              <p>2. <strong>如您违反本协议约定，或违反我们不时制定的推广规则的，我们有权对您采取警告、要求整改、中止推广、终止推广、冻结您的挣推账号、终止本协议等措施。如您的行为造成我方损失的，我方有权要求您进行全额进行赔偿（包括但不限于行政处罚、对第三方的损害赔偿、律师费、调查取证费用、诉讼费等）。</strong></p>
              <p>3. 任何一方有违法行为或违约行为时，除本协议另有约定外，违约方应向守约方承担赔偿责任。</p>
            </div>
            <div className='item'>
              <p><strong>八.  争议的解决方式</strong></p>
              <p>1. 本协议适用中华人民共和国法律。双方发生争议时，均同意先协商解决，协议未果时，<strong>双方同意向我们所在地有管辖权法院提起诉讼解决。</strong></p>
            </div>
            <div className='item'>
              <strong>
                <p><strong>九.  免责条款</strong></p>
                <p>1. 您同意：非我们主观故意或重大过失，我们对服务中出现的中断、信息删除或储存失败等，不承担任何责任。</p>
                <p>2. 鉴于网络的特殊性质，以下情形您同意我们免责：</p>
                <div className='sub-content'>
                  <p>2.1电信运营商导致的原因；</p>
                  <p>2.2法律的变化；</p>
                  <p>2.3黑客攻击或病毒侵袭；</p>
                  <p>2.4银行方面的问题；</p>
                  <p>2.5因政府行为、台风、地震、海啸、洪水、停电、战争、恐怖袭击、网络故障等不可抗力之因素，造成挣推系统障碍不能提供服务的。不可抗力可能导致挣推无法访问、访问速度缓慢、存储数据丢失、用户个人信息泄漏等不利后果。在遭受不可抗力事件时，我们可中止履行本用户协议项下的义务直至不可抗力的影响消除为止，并且不因此承担违约责任；但应尽最大努力克服该事件，减轻其负面影响。</p>
                </div>
                <p>3. 在任何情况下，您使用我们服务过程中涉及由我们的合作方或第三方提供相关服务的，服务内容由该合作方或第三方负责。用户享用相关服务时产生的争议、纠纷及损失，我们不承担任何责任。</p>
              </strong>
            </div>
            <div className='item'>
              <strong>
                <p><strong>十.  通知及送达</strong></p>
                <p>1. 本协议项下的通知如以公示方式作出，一经在挣推公示即视为已经送达。除此之外，其他向用户发布的具有专属性的通知将由挣推向用户注册时或注册后向挣推提供的电子邮箱、手机号码发送，一经发送即视为已经送达。请您密切关注电子邮箱中的邮件和信息及手机中的短信信息。</p>
              </strong>
            </div>
            <div className='item'>
              <p><strong>十一.  其它</strong></p>
              <p>1. <strong>本协议生效后，除非我们终止本协议或者您丧失挣推用户资格，否则本协议始终有效。本协议终止并不免除您根据本协议或其他有关协议、规则所应承担的义务和责任。</strong></p>
              <p>2.本协议部分条款被认定为无效时，不影响本协议其他条款的效力。</p>
              <p>3.本协议第一版于2021年7月1日发布并生效，本协议第二版于2021年11月15日发布并生效。</p>
              <p>4.我们对本协议在法律规定的范围内享有最终的解释权。</p>
            </div>
          </div>
        </div>
        <i className='iconfont icon-delete' onClick={this.props.closeFunc}></i>
      </div>
    )
  }
}

PartnerApply.propsType = {
  closeFunc: PropsType.func
}

export default PartnerApply;
